import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DuringBreak } from '../../hooks/useCurrentTimeTrackingTimeline';
import { useBreakTypes } from '../../hooks/timeTracking/useBreakTypes';
import { getBreakTypeName } from '../BreakTypeIcon';
import ResumeTimeTrackingButton from '../../pages/TimeTracking/CurrentTimeTracking/ResumeTimeTrackingButton';
import TimeUntilNow from '../../pages/TimeTracking/CurrentTimeTracking/TimeUntilNow';
import AccordionToggleButton from './AccordionToggleButton';
import CardTitle from './CardTitle';
import { roundSmCircleIconButtonStyle } from '../roundSmCircleIconButtonStyle';

type Props = {
  step: DuringBreak;
  accordionToggleKey: string;
  accordionOpen: boolean;
  accordionToggleOpen: () => void;
};

const CardHeaderDuringBreakStep: React.FC<React.PropsWithChildren<Props>> = ({
  step,
  accordionToggleKey,
  accordionOpen,
  accordionToggleOpen,
}) => {
  const { timeEntryId } = step;
  const { t } = useTranslation();
  const breakTypes = useBreakTypes();
  const breakTypeName = getBreakTypeName(breakTypes, step.breakTypeId);

  return (
    <Row className="align-items-center">
      <Col>
        <CardTitle
          title={<TimeUntilNow date={step.startTime} />}
          subtitle={
            breakTypeName
              ? t('timeTracking.current.steps.duringBreak.breakTimeWithType', {
                  type: breakTypeName,
                })
              : t('timeTracking.current.steps.duringBreak.breakTime')
          }
          accordionToggleKey={accordionToggleKey}
          accordionToggleOpen={accordionToggleOpen}
        />
      </Col>

      <Col className="col-auto">
        <ResumeTimeTrackingButton
          className="lift btn-rounded-circle me-2 d-inline-flex align-items-center justify-content-center"
          style={roundSmCircleIconButtonStyle}
          timeEntryId={timeEntryId}
        />
        <AccordionToggleButton
          eventKey={accordionToggleKey}
          open={accordionOpen}
          onClick={accordionToggleOpen}
        />
      </Col>
    </Row>
  );
};

export default CardHeaderDuringBreakStep;
